<template>
  <div class="clearfix">
    <div class="logo-box">
      <img :src="userInfo.systemLogo?userInfo.systemLogo:'/static/images/logo.png'" alt="">
      <span>{{userInfo.systemName?userInfo.systemName:'繁星数据管理平台'}}</span>
      <div class="clearfix"></div>
    </div>
    <div class="user-box">
      <span class="user-name">{{userInfo.username}}</span>
      <a class="log-out" @click="logOutFun()">退出</a>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      userInfo:JSON.parse(localStorage.getItem('UserInfo'))
    }
  },
  mounted(){
    var _this=this;
  },
  methods:{
    logOutFun:function(){
      var _this=this;
      localStorage.removeItem('Authorization');
      localStorage.removeItem('UserInfo');
      _this.$router.push({ path: '/login' });
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.logo-box{float: left;}
.logo-box img{display: block; height: 40px;width: auto; margin-top: 10px; float: left;}
.logo-box span{display: block;line-height: 60px;font-size: 20px; font-weight: bold; float: left; margin-left: 10px; color: #fff;}
.user-box{float: right;}
.user-box span,.user-box a{display: inline-block; font-size: 14px; line-height: 60px; color: #fff;}
.user-box a{margin-left: 8px;}
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/Header.vue